export default __webpack_public_path__ + "static/media/CanyonOutpost.344e8bf9.jpg";